import { Box } from "@material-ui/core";
import { useContext } from "react";
import Steps from "../../../../components/steps/Steps";
import { CorpoClinicoContext } from "../../../../context/CorpoClinicoContext";
import FormBase from "../../../../forms/FormBase";
import PhysicianRecommendationDataComponent from "../../../components/materialui/CorpoClinico/PhysicianRecommendationDataComponent";
import { PhysicianRecommendationDataFormItem } from "../../../../forms/corpoClinico/PhysicianRecommendationDataForm";


export default function PhysicianRecommendationDataStep() {

    const { state, dispatch } = useContext(CorpoClinicoContext);

    const onInputChange = (name: string, form: FormBase, value: any) => {
        dispatch({
            type: "UPDATE_FORM",
            payload: { form, value, name },
        });
    };

    const onCrudPhysicianRecommendationAction = (subTypeParam: "InsertOrUpdate" | 'Delete' | 'Cancel' | 'Edit', physicianRecommendationDataFormItem?: PhysicianRecommendationDataFormItem) => {
        dispatch({
            type: "CRUD_FORM_PHYSICIAN_RECOMMENDATION",
            payload: { subType: subTypeParam, item: physicianRecommendationDataFormItem },
        });
    };

    return (
        <div>

            <Steps.StepTitle text="Indicações de médicos para referência" />

            <Box mt={2} mb={4}>
                <PhysicianRecommendationDataComponent 
                    PhysicianRecommendationForm={state.PhysicianRecommendationDataForm}
                    onCancelItem={() => { onCrudPhysicianRecommendationAction("Cancel") }}                    
                    onInserOrUpdateItem={() => { onCrudPhysicianRecommendationAction("InsertOrUpdate") }}
                    onEditClick={(e: PhysicianRecommendationDataFormItem) => { onCrudPhysicianRecommendationAction("Edit", e) }}
                    onDeleteClick={(e: PhysicianRecommendationDataFormItem) => { onCrudPhysicianRecommendationAction("Delete", e) }}
                    onInputChange={onInputChange} />
            </Box>
        </div>

    );
}